import { action, createRequestTypes } from '../base';

export const qualityCheckActionTypes = {
  GET_QUALITY_CHECKS: createRequestTypes('GET_QUALITY_CHECKS'),
  GET_QUALITY_CHECK_BY_ID: createRequestTypes('GET_QUALITY_CHECK_BY_ID'),
  CREATE_QUALITY_CHECK: createRequestTypes('CREATE_QUALITY_CHECK'),
  UPDATE_QUALITY_CHECK: createRequestTypes('UPDATE_QUALITY_CHECK'),
  DELETE_QUALITY_CHECK: createRequestTypes('DELETE_QUALITY_CHECK'),
  GET_DOWNLOAD_QUALITY_CHECK: createRequestTypes('GET_DOWNLOAD_QUALITY_CHECK'),
  GET_QUALITY_CHECK_REPORT: createRequestTypes('GET_QUALITY_CHECK_REPORT'),
  RETEST_QUALITY_CHECK: createRequestTypes('RETEST_QUALITY_CHECK'),
  PUT_QC_ON_HOLD: createRequestTypes('PUT_QC_ON_HOLD'),
  UPDATE_QC_ASSIGNEES: createRequestTypes('UPDATE_QC_ASSIGNEES'),
};

class QualityCheckActions {

  getQualityChecks = (tenantId, entityId, entityName, status, qcType, page, limit, searchKeyword, startDate, endDate, batchId, defaultAssigneeId) => action(qualityCheckActionTypes.GET_QUALITY_CHECKS.REQUEST, {
    tenantId, entityId, entityName, status, qcType, page, limit, searchKeyword, startDate, endDate, batchId, defaultAssigneeId
  })

  getQualityChecksLoading = (qualityChecksLoading) => action(qualityCheckActionTypes.GET_QUALITY_CHECKS.LOADING, {
    qualityChecksLoading,
  })

  getQualityChecksSuccess = (qualityChecks) => action(qualityCheckActionTypes.GET_QUALITY_CHECKS.SUCCESS, {
    qualityChecks,
  })

  getQualityCheckById = (tenantId, qualityCheckId) => action(qualityCheckActionTypes.GET_QUALITY_CHECK_BY_ID.REQUEST, {
    tenantId, qualityCheckId,
  })

  getQualityCheckByIdLoading = (getQualityCheckByIdLoading) => action(qualityCheckActionTypes.GET_QUALITY_CHECK_BY_ID.LOADING, {
    getQualityCheckByIdLoading,
  })

  getQualityCheckByIdSuccess = (selectedQualityCheck) => action(qualityCheckActionTypes.GET_QUALITY_CHECK_BY_ID.SUCCESS, {
    selectedQualityCheck,
  })

  getDownloadQualityChecks = (tenantId, qualityCheckId, entityName, entityId, userId) => action(
    qualityCheckActionTypes.GET_DOWNLOAD_QUALITY_CHECK.REQUEST, {
    tenantId, qualityCheckId, entityName, entityId, userId
  },
  )

  getDownloadQualityChecksLoading = (getDownloadQualityChecksLoading) => action(qualityCheckActionTypes.GET_DOWNLOAD_QUALITY_CHECK.LOADING, {
    getDownloadQualityChecksLoading,
  })

  createQualityCheck = (payload, callback) => action(qualityCheckActionTypes.CREATE_QUALITY_CHECK.REQUEST, {
    payload,
    callback,
  })

  createQualityCheckLoading = (createQualityCheckLoading) => action(qualityCheckActionTypes.CREATE_QUALITY_CHECK.LOADING, {
    createQualityCheckLoading,
  })

  updateQualityCheck = (payload, callback) => action(qualityCheckActionTypes.UPDATE_QUALITY_CHECK.REQUEST, {
    payload,
    callback,
  })

  updateQualityCheckLoading = (updateQualityCheckLoading) => action(qualityCheckActionTypes.UPDATE_QUALITY_CHECK.LOADING, {
    updateQualityCheckLoading,
  })

  deleteQualityCheck = (payload, callback) => action(qualityCheckActionTypes.DELETE_QUALITY_CHECK.REQUEST, {
    payload,
    callback,
  })

  deleteQualityCheckLoading = (deleteQualityCheckLoading) => action(qualityCheckActionTypes.DELETE_QUALITY_CHECK.LOADING, {
    deleteQualityCheckLoading,
  })

  // get quality check report
  getQualityCheckReport = (tenantId, entityName, status, qcType, startDate, endDate, operationType, userId, callback) => action(qualityCheckActionTypes.GET_QUALITY_CHECK_REPORT.REQUEST, {
    tenantId, entityName, status, qcType, startDate, endDate, operationType, userId, callback,
  })

  getQualityCheckReportLoading = (getQualityCheckReportLoading) => action(qualityCheckActionTypes.GET_QUALITY_CHECK_REPORT.LOADING, {
    getQualityCheckReportLoading,
  })

  // Qc retest 
  retestQualityCheck = (payload, callback) => action(qualityCheckActionTypes.RETEST_QUALITY_CHECK.REQUEST, {
    payload,
    callback,
  })

  retestQualityCheckLoading = (retestQualityCheckLoading) => action(qualityCheckActionTypes.RETEST_QUALITY_CHECK.LOADING, {
    retestQualityCheckLoading,
  })

  // Qc on Hold 
  putQualityCheckOnHold = (payload, callback) => action(qualityCheckActionTypes.PUT_QC_ON_HOLD.REQUEST, {
    payload,
    callback,
  })

  putQualityCheckOnHoldLoading = (putQualityCheckOnHoldLoading) => action(qualityCheckActionTypes.PUT_QC_ON_HOLD.LOADING, {
    putQualityCheckOnHoldLoading,
  })

  updateQualityCheckAssignees = (payload, callback) => action(qualityCheckActionTypes.UPDATE_QC_ASSIGNEES.REQUEST, {
    payload,
    callback,
  })

  updateQualityCheckAssigneesLoading = (updateQualityCheckAssigneesLoading) => action(qualityCheckActionTypes.UPDATE_QC_ASSIGNEES.LOADING, {
    updateQualityCheckAssigneesLoading,
  })
}

export default new QualityCheckActions();
